import React from 'react'
import { Card } from '../../../../../../../../components/Card'
import LastBirth from './components/LastBirth'
import ExpectedBirth from './components/ExpectedBirth'
import HeatMonitor from './components/HeatMonitor'
import BirthMonitor from './components/BirthMonitor'

const Options = ({ cowid, rowid, options, refetchCow, biosensors }) => {
    return (
        <Card>
            <LastBirth
                rowid={rowid}
                lastBirth={options['last_birth']}
                refetchCow={refetchCow}
            />
            <ExpectedBirth
                rowid={rowid}
                expectedBirth={options['expected_birth']}
                refetchCow={refetchCow}
            />
            <HeatMonitor
                rowid={rowid}
                heatMonitor={options['heat_monitor']}
                refetchCow={refetchCow}
            />
            <BirthMonitor
                cowid={cowid}
                rowid={rowid}
                birthMonitor={options['birth_monitor']}
                refetchCow={refetchCow}
                biosensors={biosensors}
            />
        </Card>
    )
}

export default Options
